import { isClientSide } from 'src/utils/constants';
import {
  getEnvVariable,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT
} from 'src/utils/envVariablesHelper';

export const SSR_PROD_API_PORT = 'http://api.likie.ua:443/';
export const PROD_API_PORT = 'https://api.likie.ua/';
export const PROD_CDN_PORT = 'https://spaces.likie.ua/';
export const STAGE_CDN_PORT = 'https://spaces.likie.dp.ua/';
export const PROD_DOMAIN_CORE = 'likie.ua';
// Be sure PROD_DOMAIN doesn't have a back slash at the end! This is required for some usecases
export const PROD_DOMAIN = `https://${PROD_DOMAIN_CORE}`;
export const TEST_DOMAIN = 'https://likie.dp.ua';

export const INTERNAL_API_ERROR_CODE = 'client_internal';

const generalRequestParams = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const requestParams = (authRequired: boolean, token: string | null) => {
  if (authRequired && token) {
    return {
      ...generalRequestParams,
      headers: {
        ...generalRequestParams.headers,
        Authorization: `Basic ${token}`
      }
    };
  }
  return generalRequestParams;
};

export const getAPIDomain = (): string => {
  // return https even for server side for development
  if (getEnvVariable(NEXT_PUBLIC_ENV) === NEXT_PUBLIC_ENV_VARIANT.DEV) {
    return PROD_API_PORT;
  }
  return isClientSide ? PROD_API_PORT : SSR_PROD_API_PORT;
};
